import {colorVariablesNext} from 'core/constants';

export const BE_MAX_PAGINATION_LIMIT = 10000;

/**
 * this is a query param
 */
export const SEARCH_QUERY = 'searchQuery';

export const percentileToTitleMap = {
  bottom25: 'Bottom 25th',
  middle50: 'Middle 50',
  top25: 'Top 25th',
};

export const bandIdToColorIndexMap: Record<string, string> = {
  small: colorVariablesNext.dataTypes.Accounts[80],
  medium: colorVariablesNext.dataTypes.Accounts[60],
  large: colorVariablesNext.dataTypes.Accounts[30],
};

export const LIMIT = {
  DEFAULT_LIMIT: 5,
  SHOW_MORE_LIMIT: 1000,
} as const;

export const SUPPORT_EMAIL = 'support@ennabl.com';

export const LIMIT_ERROR_CODE = 402;

export const CUSTOM_REPORT_GROUP_ID = 'CUSTOM_AGGREGATED';
export const CUSTOM_QUERY_GROUP_ID = 'CUSTOM_QUERY';

// we have to use something different from slash, because our entity ids could have a slash
export const SUB_TAB_DELIMITER = '::';

export const nullableKeysForApolloResponse = ['timestamp'];

export const ISU_SUPPORT_URL = 'https://isusteadfast.com/contact-us/';
export const PIIB_SUPPORT_URL = 'https://www.piib.com/contact-us/';
